import Swiper from 'swiper';

import 'swiper/swiper-bundle.css';

/**
 * FAQ Videos block — horizontal nav swiper with scroll-to-row sync.
 */
export default function faqVideosModule() {
	const section = document.querySelector('section.faq-videos');

	if (!section) return;

	const navEl = section.querySelector('.js-faq-videos--nav');
	const navItems = section.querySelectorAll('.js-faq-videos--nav-item');
	const rows = section.querySelectorAll('.faq-videos__row');

	if (!navEl || !navItems.length || !rows.length) return;

	const navSwiper = new Swiper(navEl, {
		slidesPerView: 1.1,
		spaceBetween: 0,
		grabCursor: true,
		breakpoints: {
			1024: {
				slidesPerView: 3,
			},
		},
	});

	const setActiveNav = (index) => {
		navItems.forEach((item, i) => {
			item.classList.toggle('is-active', i === index);
		});

		if (navSwiper && navItems[index]) {
			navSwiper.slideTo(index);
		}
	};

	const scrollToRow = (index) => {
		const row = rows[index];

		if (!row) return;

		row.scrollIntoView({ behavior: 'smooth', block: 'start' });
		setActiveNav(index);
	};

	navItems.forEach((item, index) => {
		const trigger = item.querySelector('.js-faq-videos--nav-trigger');

		item.addEventListener('click', (event) => {
			if (event.target.closest('.faq-videos__nav-button a.c-button')) {
				return;
			}

			event.preventDefault();
			scrollToRow(index);
		});

		if (trigger) {
			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				scrollToRow(index);
			});
		}
	});

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				const index = Array.from(rows).indexOf(entry.target);

				if (index !== -1) {
					setActiveNav(index);
				}
			});
		},
		{
			root: null,
			rootMargin: '-40% 0px -40% 0px',
			threshold: 0,
		}
	);

	rows.forEach((row) => observer.observe(row));

	setActiveNav(0);
}
